<template>
  <!-- Hero -->
  <section class="hero" aria-labelledby="page-title">
    <div class="section__inner hero__inner">
      <h2 id="page-title">국제내부통제경영인증</h2>
      <p><strong>ICI Korea </strong> Recognizing Competency World-Wide</p>
    </div>
  </section>

  <main class="result-page" aria-labelledby="result-title">
    <!-- Title -->
    <!-- <header class="page-head">
      <h1 id="result-title" class="title">평가 결과 요약</h1>
      <p class="desc">제출한 응답을 바탕으로 산출된 결과입니다.</p>
    </header> -->



    <!-- ===== 중점 항목별 요약 (섹션별 Yes 비율) ===== -->
    <section class="focus-summary card" aria-labelledby="fs-title">
      <h2 id="fs-title" class="card__title">핵심 요약</h2>

        <!-- <p class="desc">
          <strong> 조직의 지배구조(Corporate Governance)</strong> 수준은 다음 기준에 따라 평가 점수를 확인할 수 있습니다.
        </p>

        <p class="desc"> <strong>Yes(예)</strong>: 해당 항목이 충족되었으며, 조직 내 지배구조·내부통제 활동이 적절하게 운영되고 있음을 의미합니다.</p>

        <p class="desc"> <strong>No(아니오)</strong>: 해당 항목이 충족되지 않았거나 개선이 필요함을 의미하며, <strong>향후 리스크 완화를 위해 보완 조치 또는 실행 계획(Action Plan)</strong>이 요구됩니다.</p>

        <p class="desc">※ 'No'로 응답된 항목은 조직의 지배구조 성숙도를 높이기 위해 우선적으로 개선해야 할 주요 영역으로 간주됩니다.</p> -->


      <div class="fs-table">
        <div class="fs-thead">
          <div class="fs-th">중점 항목</div>
          <div class="fs-th fs-th--score">평균</div>
        </div>

        <div class="fs-tbody">
          <div v-for="row in sectionStats" :key="row.sectionId" class="fs-tr">
            <div class="fs-td fs-td--label">
              <span class="fs-label-title">{{ row.sectionTitle }}</span>
              <span class="fs-label-goal">{{ row.sectionGoal }}</span>
            </div>

            <!-- Yes 비율 스케일 + 포인터 -->
            <div class="fs-td fs-td--scale">
              <div class="fs-scale" :style="{ '--score-pos': scorePosRYG(row.avg) }">
                <div class="fs-scale__bar" aria-hidden="true">
                  <span class="fs-seg fs-seg--1"></span>
                  <span class="fs-seg fs-seg--2"></span>
                  <span class="fs-seg fs-seg--3"></span>
                  <span class="fs-seg fs-seg--4"></span>
                  <span class="fs-seg fs-seg--5"></span>
                </div>
                <div class="fs-scale__pointer" role="img" aria-label="섹션 Yes 비율 위치"></div>
              </div>
              <div class="fs-scale__legend"></div>
              <p class="desc" style="margin-top:6px;">
                <!-- Yes 비율: {{ (row.avg * 100).toFixed(1) }}% / 응답 문항: {{ row.count }}개 -->
                   체크한 항목 : {{ row.count }}개

              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 전체 요약 (Yes 비율) ===== -->
    <section class="overall card" aria-labelledby="ov-title">
      <div class="ov-grid">
        <div class="ov-score">
          <div class="ov-score__big">
            {{ ACTIVE_META.label }} 영역의 자체점검 결과,
            평가점수는
            <span class="score-value" :class="scoreColorClass">
              {{ overallPct.toFixed(1) }}점
            </span>
            입니다.
          </div>
        </div>
      </div>
    </section>

      <!-- <div class="ov-desc">
        🟢 상기 질문 응답 내역을 바탕으로 한 100분위 환산
      </div> -->

    

    <!-- ===== 점수별 분석 (1=빨강, 2=노랑, 3=초록) ===== -->
    <!-- <section class="grouped card" aria-labelledby="grp-title">
      <h2 id="grp-title" class="card__title">영역별 고려사항</h2>

      <div>
        이 항목은 평가 결과를 점수(색상 등급)에 따라 구분하여, 조직의 각 영역이 어느 수준의 성숙도를 보이는지 요약·분석하는 부분입니다.
      </div>

      <div class="grid">
        <section v-for="n in [1,2,3]" :key="n" class="bucket" :data-score="n">
          <h3 class="bucket__title" :data-score="n">
            <span
              class="bucket__color"
              :class="{
                'bucket__color--red': n === 1,
                'bucket__color--yellow': n === 2,
                'bucket__color--green': n === 3
              }"
            ></span>

            <span class="bucket__label">
              <template v-if="n === 1">
                통제 및 지배구조 리스크를 수용 가능한 수준으로 낮추기 위해 상당한 보완과 개선이 필요한 영역
              </template>
              <template v-else-if="n === 2">
                일정 부분의 보완과 개선이 필요하여, 강화되지 않을 경우 리스크 수준이 상승할 수 있는 영역
              </template>
              <template v-else>
                충분히 효과적으로 운영되고 있으며, 통제 및 지배구조 리스크가 수용 가능한 최소 수준으로 유지되고 있는 영역
              </template>
            </span>
          </h3>

          <ul class="bucket__list">
            <li
              v-for="group in scoreBuckets[n]"
              :key="group.sectionId"
              class="bucket__group"
            >
              <strong class="bucket__group-title">
                [{{ group.sectionTitle }}]
              </strong>

              <ul class="bucket__group-list">
                <li
                  v-for="(q, idx) in group.items"
                  :key="idx"
                  class="item"
                >
                  {{ q.queItem }}
                </li>
              </ul>
            </li>

            <li v-if="!scoreBuckets[n]?.length" class="item">
              해당 항목 없음
            </li>
          </ul>

        </section>
      </div>
    </section> -->
    <!-- ===== 점수별 분석 → Yes/No 기준 고려사항 ===== -->
    <section class="grouped card" aria-labelledby="grp-title">
      <h2 id="grp-title" class="card__title">영역별 미흡사항</h2>

      <div class="grid">
        <!-- low(0~39%), mid(40~79%), high(80%~) 세 구간 -->
        <section
          v-for="bucket in ['low', 'mid', 'high']"
          :key="bucket"
          class="bucket"
          :data-bucket="bucket"
        >
          <h3 class="bucket__title">
            <!-- 왼쪽 색 막대 -->
            <span
              class="bucket__color"
              :class="{
                'bucket__color--red': bucket === 'low',
                'bucket__color--yellow': bucket === 'mid',
                'bucket__color--green': bucket === 'high'
              }"
            ></span>

            <!-- 오른쪽 텍스트 -->
            <span class="bucket__label">
              <template v-if="bucket === 'low'">
                <strong>통제 및 지배구조 리스크를 수용 가능한 수준으로 낮추기 위해 상당한 보완과 개선이 필요한 영역</strong>
              </template>

              <template v-else-if="bucket === 'mid'">
                <strong>일정 부분의 보완과 개선이 필요하여, 강화되지 않을 경우 리스크 수준이 상승할 수 있는 영역</strong>
              </template>

              <template v-else>
                <strong>충분히 효과적으로 운영되고 있으며, 통제 및 지배구조 리스크가 수용 가능한 최소 수준으로 유지되고 있는  영역</strong>
              </template>
            </span>
          </h3>

          <!-- 하단: 해당 구간에서 No인 문항만 섹션별로 그룹 -->
          <ul class="bucket__list">
            <!-- 섹션 단위 그룹 -->
            <li
              v-for="group in pctBuckets[bucket]"
              :key="group.sectionId"
              class="bucket__group"
            >
              <strong class="bucket__group-title">
                [{{ group.sectionTitle }}]
              </strong>

              <ul class="bucket__group-list">
                <li
                  v-for="(q, idx) in group.items"
                  :key="idx"
                  class="item"
                >
                  {{ q.queItem }}
                </li>
              </ul>
            </li>

            <!-- 해당 구간에 No 항목이 하나도 없을 때 -->
            <li v-if="!pctBuckets[bucket]?.length" class="item">
              해당 구간에 No(미충족)로 응답된 항목이 없습니다.
            </li>
          </ul>
        </section>
      </div>
    </section>



    <!-- ===== 기준별 상세 표 (선택값을 설문 양식(RYG) 그대로 표시) ===== -->
    <!-- <section
      v-for="(sec, si) in sections"
      :key="sec.key"
      class="audit-section"
      :aria-labelledby="`sec-title-${si}`"
    >
      <h2 :id="`sec-title-${si}`" class="ag-title">{{ sec.title }}</h2>
      <p class="ag-goal" v-if="sec.goal">목표: {{ sec.goal }}</p>

      <div class="ag-table" role="table" :aria-label="`${sec.title} 설문 표`">
        <div class="ag-thead" role="row">
          <div class="ag-th ag-th--no" role="columnheader">구분</div>
          <div class="ag-th ag-th--q" role="columnheader">질문항목</div>
          <div class="ag-th ag-th--score" role="columnheader">응답</div>
          <div class="ag-th ag-th--note" role="columnheader">비고</div>
        </div>

        <ul class="ag-tbody">
          <li
            v-for="(q, qi) in sec.items"
            :key="q.questionCode || q.key || qi"
            class="ag-tr"
            role="row"
          >
            <div class="ag-td ag-td--no" role="cell">
              {{ globalIndexMap.get(q) }}
            </div>


            <div class="ag-td ag-td--q" role="cell">
              <label class="ag-q">{{ q.queItem || q.text }}</label>
            </div>

            <div class="ag-td2 td--score" role="cell">
              <fieldset class="score-ryg" :aria-labelledby="`res-${si}-${qi}-label`">
                <legend :id="`res-${si}-${qi}-label`" class="sr-only">문항 색상 선택</legend>

                <label class="ryg">
                  <input
                    type="radio"
                    :name="`res-${si}-${qi}`"
                    :id="`res-${si}-${qi}-r`"
                    value="1"
                    :checked="Number(q.score) === 1"
                    disabled
                  />
                  <span class="ryg__btn ryg__btn--red" aria-label="빨강(미흡)"></span>
                </label>

                <label class="ryg">
                  <input
                    type="radio"
                    :name="`res-${si}-${qi}`"
                    :id="`res-${si}-${qi}-y`"
                    value="2"
                    :checked="Number(q.score) === 2"
                    disabled
                  />
                  <span class="ryg__btn ryg__btn--yellow" aria-label="노랑(보통)"></span>
                </label>

                <label class="ryg">
                  <input
                    type="radio"
                    :name="`res-${si}-${qi}`"
                    :id="`res-${si}-${qi}-g`"
                    value="3"
                    :checked="Number(q.score) === 3"
                    disabled
                  />
                  <span class="ryg__btn ryg__btn--green" aria-label="초록(우수)"></span>
                </label>
              </fieldset>
            </div>

            <div class="ag-td2 ag-td--note" role="cell">
              {{ q.note || '-' }}
            </div>
          </li>
        </ul>
      </div>
    </section> -->

  <!-- ===== 기준별 상세 표 (Yes / No 표시) ===== -->
    <section
      v-for="(sec, si) in sections"
      :key="sec.key"
      class="audit-section"
      :aria-labelledby="`sec-title-${si}`"
    >
      <h2 :id="`sec-title-${si}`" class="ag-title">{{ sec.title }}</h2>
      <p class="ag-goal" v-if="sec.goal">목표: {{ sec.goal }}</p>

      <div class="ag-table" role="table" :aria-label="`${sec.title} 설문 표`">
        <!-- Head -->
        <div class="ag-thead" role="row">
          <div class="ag-th ag-th--no" role="columnheader">구분</div>
          <div class="ag-th ag-th--q" role="columnheader">질문항목</div>
          <div class="ag-th ag-th--score" role="columnheader">응답(Yes / No)</div>
          <div class="ag-th ag-th--note" role="columnheader">비고</div>
        </div>

        <!-- Body -->
        <ul class="ag-tbody">
          <li
            v-for="(q, qi) in sec.items"
            :key="q.questionCode || q.key || qi"
            class="ag-tr"
            role="row"
          >
            <div class="ag-td ag-td--no" role="cell">
              {{ globalIndexMap.get(q) }}
            </div>

            <div class="ag-td ag-td--q" role="cell">
              <label class="ag-q">{{ q.queItem || q.text }}</label>
            </div>

            <!-- 읽기전용 Yes / No 칩 -->
            <div class="ag-td2 td--score" role="cell">
              <div class="score-yn score-yn--readonly">
                <span
                  v-if="q.score === 1"
                  class="yn-chip yn-chip--yes"
                >
                  Yes
                </span>
                <span
                  v-else-if="q.score === 0"
                  class="yn-chip yn-chip--no"
                >
                  No
                </span>
                <span
                  v-else
                  class="yn-chip yn-chip--none"
                >
                  미응답
                </span>
              </div>
            </div>

            <div class="ag-td2 ag-td--note" role="cell">
              {{ q.note || '-' }}
            </div>
          </li>
        </ul>
      </div>
    </section>

    <div class="consulting-note">
      <p>
        본 자가진단 결과는 조직의 내부통제 성숙도 수준을 파악하기 위한 
        <strong>1차 평가 자료</strong>로 활용됩니다.
      </p>

      <p>
        미흡하거나 개선이 필요한 항목에 대해서는 한국내부통제협회의
        <strong>「국제 내부통제경영인증 컨설팅」</strong>을 통해
        체계적인 개선 및 국제 인증 절차를 진행할 수 있습니다.
      </p>

      <p>
        별도 컨설팅을 원하시는 경우, 한국내부통제협회 담당자에게 문의하시면 
        내부통제 체계 고도화 및 국제 인증 절차에 대한 상세 안내를 받으실 수 있습니다.
      </p>

      <p class="contact">
        ▸ <strong>컨설팅 문의: 070-4489-7447</strong>
      </p>
    </div>

  </main>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'

/** ===== 설문 메타 ===== */
const SURVEY_META = {
  SURV001: {
    label: '최고경영진',
    criteria: {
      '1': { title: '기업 비전 및 전략적 방향성', goal: '비전, 전략적 기획, 리더십이 경쟁력 있고 수익성 있는 조직을 창출하는지 평가.' },
      '2': { title: '윤리적 리더십', goal: '조직의 가치·윤리를 일상 운영에 반영하는 역할을 평가' },
      '3': { title: '비즈니스 프로세스 완결성', goal: '목표 달성을 위한 경영 프로세스의 완결성 평가' },
      '4': { title: '직원·고객·공급자와의 접근성', goal: '이해관계자와의 상호작용 및 경영진 참여도 평가' },
      '5': { title: '고객 및 이해관계자 중심', goal: '고객·주주·시장과의 관계 및 만족도 관리 평가' },
      '6': { title: '재무성과 및 사업성과', goal: 'CEO의 수익성·성장성·고객 만족도 달성 능력 평가' },
      '7': { title: '사회적 책임 및 지역사회 기여', goal: '기업의 사회적 책임, 윤리, 지역사회 기여 평가' },
    },
  },

  SURV002: {
    label: '이사회',
    criteria: {
      '1': { title: '이사회 권한 및 관리', goal: '이사회가 효과적으로 기능하기 위해 필요한 권한과 방향성에 대한 평가' },
      '2': { title: 'CEO 보상 체계의 효과성', goal: '현행 및 예상되는 기업 성과와 관련하여 CEO 보상 체계를 평가' },
      '3': { title: '전략적 기획에 대한 감독', goal: '전략적 기획의 완전성과 합리성에 대한 평가' },
      '4': { title: '재무 건전성 감독', goal: '기업의 재무 자산 관리 책임 평가' },
      '5': { title: '경영 성과 및 운영 감독', goal: '사업 운영의 적정성과 합리성에 대한 평가' },
      '6': { title: '최고경영자(CEO)에 대한 감독', goal: 'CEO가 조직을 관리하고 이사회의 의사를 실행하는 데 있어 효과성 평가' },
      '7': { title: '주주 및 이해관계자 권익 보호에 대한 감독', goal: '이사회가 주주의 이익을 대변하는 데 있어 효과성 평가' },
    },
  },

  SURV003: {
    label: '내부감사인',
    criteria: {
      '1': { title: '내부감사 인력의 역량', goal: '내부감사가 그들의 책임을 수행할 수 있는 역량에 대한 평가' },
      '2': { title: '감사 범위의 완전성', goal: '내부감사인의 감사 범위의 완전성 평가' },
      '3': { title: '내부감사 독립성 유지', goal: '최고경영진이 감사 독립성을 침해할 수 있는지 여부 평가' },
      '4': { title: '내부감사 권한 적정성', goal: '내부감사 기능이 그들의 책임을 수행할 수 있는 권한에 대한 평가' },
      '5': { title: '내부감사 인식·비밀보장·제보자 보호', goal: '직원을 감시자로 활용하는 효과성과, 보고자를 보호 및 보상하는 체계 평가' },
      '6': { title: '내부통제 평가', goal: '내부통제를 평가하는 데 있어 내부감사 기능의 효과성 평가' },
      '7': { title: '보고서 및 권고사항의 완전성, 합리성, 명확성', goal: '작성된 감사보고서의 명확성, 완전성, 합리성 평가' },
    },
  },

  SURV004: {
    label: '감사위원회',
    criteria: {
      '1': { title: '감사위원회의 역할과 책임', goal: '감사위원회가 명확한 역할·책임 규정을 보유하고 있으며, 해당 책임이 효과적인 감사위원회의 기준과 일치하는지 평가' },
      '2': { title: '감사위원회의 역량', goal: '위원들의 역량, 회계·감사 관행에 대한 이해 수준, 책무 수행 능력을 평가' },
      '3': { title: '재무 감독 책임의 이행', goal: '재무보고의 적정성·완전성·무결성을 검토하는 감사위원회의 감독 역할 평가' },
      '4': { title: '감사 감독 책임의 이행', goal: '외부감사인 및 내부감사인과의 관계, 임명권, 감독 역할 등 전반적인 감사 프로세스 감독 평가' },
      '5': { title: '기업 지배구조에 대한 감독', goal: '윤리강령, 윤리 준수 프로세스, 규제 준수 여부 등에 대한 감독 역할 평가' },
      '6': { title: '내부통제 감독', goal: '내부통제 시스템의 적정성을 평가' },
      '7': { title: '경영진의 회계 관행에 대한 감독', goal: '경영진 회계 관행의 적정성과 건전성을 평가' },
    },
  },

  SURV005: {
    label: '외부감사인',
    criteria: {
      '1': { title: '외부감사 인력의 독립성', goal: '외부감사 인력의 독립성을 평가' },
      '2': { title: '감사 범위의 완전성', goal: '외부감사 범위가 충분하고 적절한지 평가' },
      '3': { title: '내부통제시스템에 대한 의존도', goal: '외부감사인이 내부통제 시스템을 감사 범위 설정 시 얼마나 의존하는지 평가' },
      '4': { title: '내부감사인에 대한 의존도', goal: '내부감사 기능의 효과성 판단 및 외부감사가 내부감사 업무에 의존하는 수준 평가' },
      '5': { title: '법규·규정 및 회계 관행 준수 평가의 완전성', goal: '관련 법규 및 회계 관행 준수 여부 평가 절차의 완전성 및 보고 적절성 검토' },
      '6': { title: '최고경영진 평가의 완전성', goal: '최고경영진의 경영 관행 평가 및 그 보고 방식의 적절성 평가' },
      '7': { title: '감사보고서 및 권고사항의 완전성·타당성·명확성', goal: '외부감사보고서의 유용성, 명확성, 타당성 평가' },
    },
  },
}

/** 섹션 평균 Yes 비율(0~1)을 퍼센트로 변환해서
 *  low(0~39), mid(40~79), high(80~) 세 구간으로 나눠
 *  각 구간 안에 'No(0)'로 응답된 항목만 섹션별로 묶기
 */
const pctBuckets = computed(() => {
  const buckets = {
    low: [],   // 0~39%
    mid: [],   // 40~79%
    high: [],  // 80%~
  }

  // sectionStats -> { sectionId, avg, sectionTitle, ... }
  const statMap = new Map(
    sectionStats.value.map(s => [String(s.sectionId), s])
  )

  // 각 구간별 섹션 그룹 맵 (중복 방지)
  const groupMaps = {
    low: new Map(),
    mid: new Map(),
    high: new Map(),
  }

  for (const it of data.value.items) {
    // No만 대상
    // if (Number(it.score) !== 0) continue
    // No(0)만 대상 - 문자열/undefined/null은 normalizeScore로 걸러줌
   const sc = normalizeScore(it.score)
   if (sc !== 0) continue

    const sid = String(it.sectionId ?? '')
    const stat = statMap.get(sid)
    if (!stat) continue

    const pct = stat.avg * 100
    let bucketKey

    if (pct <= 39) {
      bucketKey = 'low'
    } else if (pct < 80) {
      // 40 ~ 79%
      bucketKey = 'mid'
    } else {
      // 80% 이상
      bucketKey = 'high'
    }

    const groupsMap = groupMaps[bucketKey]

    let group = groupsMap.get(sid)
    if (!group) {
      group = {
        sectionId: sid,
        sectionTitle: stat.sectionTitle || sid,
        items: [],
      }
      groupsMap.set(sid, group)
      buckets[bucketKey].push(group)
    }

    group.items.push({
      queItem: it.queItem || it.text,
      raw: it,
    })
  }

  return buckets
})



// const scoreColorClass = computed(() => {
//   const score = overallPct.value
//   if (score <= 30) return 'score--red'
//   if (score < 70)  return 'score--yellow'
//   return 'score--green'
// })
function normalizeScore(score) {
  if (score === 0 || score === 1) return score
  if (score === '0' || score === '1') return Number(score)
  return null
}


/** ===== 상태 ===== */
const router = useRouter()
const data = ref({
  surveyCode: '',
  items: [], // [{sectionId, sectionTitle, questionCode, queItem, score(1~3), addInfo, note}]
})

onMounted(() => {
  const raw = sessionStorage.getItem('audit-committee-survey')
  if (!raw) {
    alert('결과 데이터가 없습니다. 설문을 먼저 제출해 주세요.')
    router.replace('/survey')
    return
  }
  try {
    const parsed = JSON.parse(raw)
    data.value = {
      surveyCode: parsed.surveyCode,
      items: Array.isArray(parsed.items) ? parsed.items : [],
    }
  } catch (e) {
    console.error(e)
    alert('결과 데이터가 손상되었습니다. 다시 제출해 주세요.')
    router.replace('/survey')
  }
})

/** 활성 메타 */
const activeSurveyCode = computed(() => data.value.surveyCode || 'SURV003')
const ACTIVE_META = computed(() => SURVEY_META[activeSurveyCode.value] || { label: '', criteria: {} })
const CRITERIA_META = computed(() => ACTIVE_META.value.criteria || {})

function sectionMeta(sectionId) {
  const sid = String(sectionId ?? '')
  return CRITERIA_META.value[sid] || { title: `기준 ${sid}`, goal: '' }
}

/** 1~3 평균을 0~100%로 (1→0%, 3→100%) */
// function scorePosRYG(avg) {
//   if (!avg || isNaN(avg)) return '0%'
//   const pct = ((avg - 1) / 2) * 100
//   const clamp = Math.max(0, Math.min(100, pct))
//   return `${clamp.toFixed(2)}%`
// }

/** 섹션별 평균(1~3만 포함) */
// const sectionStats = computed(() => {
//   const map = new Map()
//   for (const it of data.value.items) {
//     const sid = String(it.sectionId ?? '')
//     if (!map.has(sid)) map.set(sid, { sectionId: sid, title: '', sum: 0, count: 0 })
//     const row = map.get(sid)
//     const sc = Number(it.score ?? 0)
//     if (sc >= 1 && sc <= 3) {
//       row.sum += sc
//       row.count += 1
//     }
//   }
//   return [...map.entries()]
//     .sort((a, b) => Number(a[0]) - Number(b[0]))
//     .map(([sid, r]) => {
//       const meta = sectionMeta(sid)
//       const avg = r.count ? r.sum / r.count : 0
//       return { sectionId: sid, sectionTitle: meta.title, sectionGoal: meta.goal, avg, count: r.count }
//     })
// })

/** 전체 평균/백분률 + 분포 */
// const answeredItems = computed(() => data.value.items.filter(it => [1,2,3].includes(Number(it.score))))
// const answeredCount = computed(() => answeredItems.value.length)
// const overallAvg = computed(() => {
//   const n = answeredCount.value
//   if (!n) return 0
//   const sum = answeredItems.value.reduce((acc, it) => acc + Number(it.score), 0)
//   return sum / n
// })
// const overallPct = computed(() => {
//   const avg = overallAvg.value
//   if (!avg) return 0
//   return ((avg - 1) / 2) * 100
// })
const dist = computed(() => {
  const d = { r: 0, y: 0, g: 0 }
  for (const it of answeredItems.value) {
    const s = Number(it.score)
    if (s === 1) d.r++
    else if (s === 2) d.y++
    else if (s === 3) d.g++
  }
  return d
})

// const scoreBuckets = computed(() => {
//   const buckets = { 1: [], 2: [], 3: [] }

//   // 점수별 섹션 그룹을 관리할 Map (중복 섹션 묶기용)
//   const groupMaps = {
//     1: new Map(),
//     2: new Map(),
//     3: new Map(),
//   }

//   for (const it of data.value.items) {
//     const s = Number(it.score ?? 0)
//     if (s < 1 || s > 3) continue

//     const sectionId = it.sectionId
//     const meta = sectionMeta(sectionId)
//     const sectionTitle = meta?.title || sectionId

//     // 점수별 Map에서 섹션 그룹 찾기
//     let group = groupMaps[s].get(sectionId)
//     if (!group) {
//       group = {
//         sectionId,
//         sectionTitle,
//         items: [],
//       }
//       groupMaps[s].set(sectionId, group)
//       buckets[s].push(group)
//     }

//     // 해당 섹션 그룹에 질문 추가
//     group.items.push({
//       queItem: it.queItem || it.text,
//       raw: it, // 필요하면 원본도 같이 보관
//     })
//   }

//   return buckets
// })

/** Yes 비율(0.0~1.0)을 0~100%로 변환 */
function scorePosRYG(ratio) {
  if (ratio == null || isNaN(ratio)) return '0%'
  const r = Math.max(0, Math.min(1, Number(ratio)))
  const pct = r * 100
  return `${pct.toFixed(2)}%`
}

/** 섹션별 Yes 비율( score: 0 또는 1 ) */
const sectionStats = computed(() => {
  const map = new Map()
  for (const it of data.value.items) {
    const sid = String(it.sectionId ?? '')
    if (!map.has(sid)) {
      map.set(sid, { sectionId: sid, sumYes: 0, count: 0 })
    }
    const row = map.get(sid)
    const sc = it.score

    if (sc === 0 || sc === 1) {
      row.count += 1
      if (sc === 1) row.sumYes += 1
    }
  }

  return [...map.entries()]
    .sort((a, b) => Number(a[0]) - Number(b[0]))
    .map(([sid, r]) => {
      const meta = sectionMeta(sid)
      const avg = r.count ? r.sumYes / r.count : 0 // 0~1
      return {
        sectionId: sid,
        sectionTitle: meta.title,
        sectionGoal: meta.goal,
        avg,
        count: r.count,
      }
    })
})

/** 전체 Yes 비율 */
// const answeredItems = computed(() =>
//   data.value.items.filter(it => [0, 1].includes(Number(it.score)))
// )
const answeredItems = computed(() =>
  data.value.items.filter(it => it.score === 0 || it.score === 1)
)

const answeredCount = computed(() => answeredItems.value.length)

// const overallPct = computed(() => {
//   const n = answeredCount.value
//   if (!n) return 0
//   const yesCount = answeredItems.value.reduce(
//     (acc, it) => acc + (Number(it.score) === 1 ? 1 : 0),
//     0
//   )
//   return (yesCount / n) * 100
// })

const overallPct = computed(() => {
  const total = data.value.items.length          // 전체 문항 수(미응답 포함)
  if (!total) return 0

  const yesCount = data.value.items.reduce((acc, it) => {
    // 1만 Yes로 인정, 나머지(0, null, undefined, '', 기타)는 0점
    return acc + (normalizeScore(it.score) === 1 ? 1 : 0)
  }, 0)

  return (yesCount / total) * 100
})


const scoreColorClass = computed(() => {
  const score = overallPct.value
  if (score <= 30) return 'score--red'
  if (score < 70) return 'score--yellow'
  return 'score--green'
})

/** Yes / No 버킷 (0 = No, 1 = Yes) */
const scoreBuckets = computed(() => {
  const buckets = { 0: [], 1: [] }
  const groupMaps = {
    0: new Map(),
    1: new Map(),
  }

  for (const it of data.value.items) {
    const s = Number(it.score ?? -1)
    if (s !== 0 && s !== 1) continue

    const sectionId = it.sectionId
    const meta = sectionMeta(sectionId)
    const sectionTitle = meta?.title || sectionId

    let group = groupMaps[s].get(sectionId)
    if (!group) {
      group = {
        sectionId,
        sectionTitle,
        items: [],
      }
      groupMaps[s].set(sectionId, group)
      buckets[s].push(group)
    }

    group.items.push({
      queItem: it.queItem || it.text,
      raw: it,
    })
  }

  return buckets
})

/** 결과 상세 표용: sectionId로 그룹핑 */
const sections = computed(() => {
  const map = new Map()
  for (const it of data.value.items) {
    const sid = String(it.sectionId ?? '')
    if (!map.has(sid)) map.set(sid, [])
    map.get(sid).push(it)
  }
  return [...map.keys()]
    .sort((a, b) => Number(a) - Number(b))
    .map(sid => {
      const meta = sectionMeta(sid)
      const rows = (map.get(sid) || []).slice()
      rows.sort((a, b) => String(a.questionCode || '').localeCompare(String(b.questionCode || '')))
      return { key: `sec_${sid}`, title: meta.title, goal: meta.goal, items: rows }
    })
})

/** 전체 아이템 순번 매핑 (섹션 구분 없이 1,2,3...) */
const globalIndexMap = computed(() => {
  const map = new Map()
  let counter = 1

  for (const sec of sections.value) {
    for (const it of sec.items) {
      map.set(it, counter)
      counter++
    }
  }

  return map
})


</script>

<style scoped>
/* 공통 규격 */
.result-page{
  max-width:1200px; margin:0 auto; display:grid; gap:24px;
  padding:20px 16px 40px; background:#fff;
  font-family:'Noto Sans KR', sans-serif;
}
.title{ font-size:2.025rem; font-weight:700; }
.desc, p{ font-size:0.95rem; }
.page-head{ display:grid; gap:8px; }


.desc strong{
  font-weight: 700;
}
/* Hero */
.hero{
  background:
    linear-gradient(rgba(13, 6, 20, .65), rgba(13, 6, 20, .65)),
    url('/src/assets/iicc-main.jpeg') center 70% / 65% no-repeat;
  color:#fff; margin-bottom:20px;
}
.hero__inner{ padding:130px 16px; text-align:center; }
.hero h2{ font-family:'Noto Sans KR', sans-serif; font-weight:700; color:#fff; font-size:2.5rem; letter-spacing:-1px; line-height:1.3; }
.hero p{ font-family:'Noto Sans KR', sans-serif; font-size:1rem; color:rgba(255,255,255,.9); margin-top:12px; letter-spacing:-.3px; line-height:1.6; }
.hero p strong{ font-size:1.225rem; font-weight:700; }

.card{ display:grid; gap:16px; padding:16px;
   /* border:1px solid #e5e7eb; border-radius:14px; */
    background:#fff; }
.card__title{ font-weight:700; font-size: 1.625rem; }

/* ===== 전체 요약 ===== */
.ov-grid{ display:grid;  gap:16px; align-items:center;
   background-color:#f1f1f1; border-radius:4px; padding: 16px; text-align: center;

}
.ov-score__big{ font-size:2.25rem; font-weight:800; line-height:1; }
.ov-dist{ display:grid; gap:6px; }
.dot{ display:inline-block; width:10px; height:10px; border-radius:50%; margin-right:6px; transform:translateY(1px); }
.dot--r{ background:#ef4444; }
.dot--y{ background:#f59e0b; }
.dot--g{ background:#10b981; }

.ov-score__big {
  font-size: 1.6rem;   /* 기존 2.25rem보다 보기 좋은 크기 */
  font-weight: 700;
  line-height: 1.4;
}

.ov-score__big {
  font-size: 1.6rem;
  font-weight: 700;
  line-height: 1.4;
}

/* 숫자 전용 색상 */
.score-value.score--red {
  color: #dc2626; /* Red */
}

.score-value.score--yellow {
  color: #d97706; /* Amber */
}

.score-value.score--green {
  color: #16a34a; /* Green */
}
.ov-desc {
  font-size: 0.95rem;
  font-weight: 500;
  color: #10b981;
}


/* ===== 3색 스케일 ===== */
.fs-scale{ position:relative; display:grid; align-items:center; }

/* ====== 5단계 색상 스케일 ====== */
.fs-scale__bar {
  display: flex;
  height: 18px;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: inset 0 0 0 1px rgba(0,0,0,.1);
}

.fs-seg { flex: 1; }

/* 단계별 색상 (빨강→주황→노랑→연두→초록) */
.fs-seg--1 { background: #dc2626; } /* Red 600 : 미흡 */
.fs-seg--2 { background: #f97316; } /* Orange 500 : 보완 필요 */
.fs-seg--3 { background: #facc15; } /* Yellow 400 : 보통 */
.fs-seg--4 { background: #84cc16; } /* Lime 500 : 양호 */
.fs-seg--5 { background: #22c55e; } /* Green 500 : 우수 */


.fs-scale__pointer {
  position: absolute;
  left: calc(var(--score-pos, 0%));
  top: -10px; /* ⬆️ 위쪽으로 배치 */
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 8px solid #111; /* ⬆️ 방향 반전 */
  transform: translateX(-50%);
}

.fs-scale__legend{ display:flex; justify-content:space-between; font-size:.85rem; color:#6b7280; padding:0 2px; }

/* ===== 중점 항목 요약 테이블 ===== */
.focus-summary .fs-table{ display:grid; gap:0 }
.fs-thead,.fs-tr{ display:grid; grid-template-columns:1fr 360px; }
.fs-thead{ background:#1d2088; color:#fff; border-radius:10px 10px 0 0; }
.fs-th,.fs-td{ padding:12px; border-top:1px solid #e5e7eb; }
.fs-thead .fs-th{ border-top:0; font-weight:700; }
.fs-td--label{ display:flex; flex-direction: column; align-items: flex-start; justify-content: center; gap: 10px; }
.fs-td--scale{ display:grid; gap:6px; align-items:center; }
.fs-label-title {
  font-weight: 700; /* 기본 weight */
}
.fs-tbody {
   border:1px solid #e5e7eb; border-radius:14px;
}
.fs-label-goal {
  display: inline-block;
  font-weight: 400; /* 강조 */
}


/* ===== 점수대별 그룹 ===== */
/* .grouped .grid{ display:grid; grid-template-columns: repeat(1, 1fr); gap:16px;
      border:1px solid #e5e7eb; border-radius:14px; padding:16px;
  }
.bucket{ display:grid; gap:10px; padding:12px; border:1px solid #e5e7eb; border-radius:12px; background:#fafafa; }
.bucket[data-score="1"] .badge{ background:#fee2e2; }
.bucket[data-score="2"] .badge{ background:#fef3c7; }
.bucket[data-score="3"] .badge{ background:#dcfce7; }
.badge{ display:inline-flex; align-items:center; padding:.35rem .6rem; font-weight:700; font-size:1.05rem; color:#111; }
.bucket__list{ display:grid; gap:8px; }
.item{ font-size:.95rem; line-height:1.6; } */

/* ===== 영역별 고려사항(버킷) ===== */
.grouped .grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}

/* 버킷 하나(빨강/노랑/초록 세트) */
.bucket {
  display: grid;
  gap: 0;
}

/* 사진처럼: 왼쪽 색 막대 + 오른쪽 남색 바 + 흰 글씨 */
.bucket__title {
  display: grid;
  grid-template-columns: 80px 1fr; /* 왼쪽 컬러, 오른쪽 텍스트 */
  margin: 0;
  background: #02245c;            /* 남색 배경 */
  color: #ffffff;
  font-size: 0.95rem;
  font-weight: 700;
}

/* 왼쪽 색 막대 */
.bucket__color {
  min-height: 44px;
}

/* 색상 정의 (빨강/노랑/초록) */
.bucket__color--red {
  background: linear-gradient(to right, #dc2626 0%, #dc2626 50%, #f97316 50%, #f97316 100%);
}
.bucket__color--yellow {
  background: linear-gradient(to right, #facc15 0%, #facc15 50%, #84cc16 50%, #84cc16 100%);
}
.bucket__color--green {
  background: #16a34a;
}

/* 오른쪽 텍스트 영역 */
.bucket__label {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  line-height: 1.6;
}

/* 버킷들 사이 검정 라인(사진 느낌) */
.bucket + .bucket {
  /* border-top: 6px solid #000000; */
  padding-top: 6px;
}

/* 하단 질문 리스트 카드 */
.bucket__list {
  display: grid;
  gap: 8px;
  padding: 12px 16px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-top: none; /* 위에 컬러 바와 자연스럽게 붙게 */
}

.item {
  font-size: 0.95rem;
  line-height: 1.6;
}

/* 항목 홀짝 배경 */
.bucket__list .item:nth-child(even) {
  /* background: #eeeeee; */
  padding: 2px 0px;
}

.bucket__list .item:nth-child(odd) {
  background: transparent; /* 기존 배경 유지 */
  padding: 2px 0px;
}



/* ===== 상세 표 ===== */
.audit-section{ display:grid; gap:12px; }
.ag-title{ font-size:1.625rem; font-weight:700; }
.ag-goal{ font-size:0.95rem; }

.ag-table{ display:grid; gap:0; border:1px solid #e5e7eb; border-radius:12px; overflow:hidden; }
.ag-thead{ display:grid; grid-template-columns:72px 1fr 200px 250px; background:#0f172a; color:#fff; justify-items: center; }
.ag-th{ padding:12px 12px; font-weight:700; }
.ag-tbody{ display:grid; gap:0; }
.ag-tr{ display:grid; grid-template-columns:72px 1fr 200px 250px; border-top:1px solid #e5e7eb; background:#fff; }
.ag-td{ padding:12px; display:flex; align-items:center; }
.ag-td2{ padding:12px; display:flex; align-items:center; justify-content: center; }
.ag-td--no{ justify-content:center; color:#6b7280; }
.ag-td--q{ align-items:flex-start; }
.ag-q{ line-height:1.6; }

/* ===== 설문과 동일한 RYG 라디오 (읽기전용 표시) ===== */
/* .score-ryg{
  display:grid; grid-auto-flow:column; gap:10px; justify-content:center; align-items:center;
}
.ryg{ display:grid; place-items:center; }
.ryg input{ position:absolute; opacity:0; width:0; height:0; }
.ryg__btn{
  display:inline-flex; align-items:center; justify-content:center;
  min-width:10px; height:10px; padding:12px; border-radius:999px;
  border:1px solid #d1d5db; background:#f9fafb; font-size:0.95rem; font-weight:700;
  user-select:none; cursor:not-allowed; transition: transform .06s ease, box-shadow .12s ease, background .12s ease, color .12s ease, border-color .12s ease;
}
.ryg__btn--red{    background:#fee2e2; border-color:#fecaca; color:#b91c1c; }
.ryg__btn--yellow{ background:#fef3c7; border-color:#fde68a; color:#b45309; }
.ryg__btn--green{  background:#dcfce7; border-color:#bbf7d0; color:#047857; }

.ryg input:checked + .ryg__btn--red{    background:#ef4444; border-color:#ef4444; color:#fff; }
.ryg input:checked + .ryg__btn--yellow{ background:#f59e0b; border-color:#f59e0b; color:#111; }
.ryg input:checked + .ryg__btn--green{  background:#10b981; border-color:#10b981; color:#fff; }

.sr-only{
  position:absolute; width:1px; height:1px; padding:0; margin:-1px;
  overflow:hidden; clip:rect(0,0,0,0); white-space:nowrap; border:0;
} */

/* 반응형 */
@media (max-width:1200px){
  .fs-thead,.fs-tr{ grid-template-columns:1fr 300px; }
  .ag-thead,.ag-tr{ grid-template-columns:60px 1fr 240px 220px 200px; }
}
@media (max-width:992px){
  .ov-grid{ grid-template-columns: 1fr; }
  .fs-thead,.fs-tr{ grid-template-columns:1fr 260px; }
  .ag-thead,.ag-tr{ grid-template-columns:52px 1fr 200px 1fr 1fr; }
}
@media (max-width:768px){
  .fs-thead{ display:none; }
  .fs-tr{ grid-template-columns:1fr; }
  .fs-th,.fs-td{ border-top:0; padding:8px 0; }

  .ag-thead{ display:none; }
  .ag-tr{ grid-template-columns:1fr; gap:8px; border-top:1px solid #e5e7eb; padding:10px 12px; }
  .ag-td{ padding:0; }
  .ag-td--q{ order:2; }
  .td--score{ order:3; }
  .ag-td--extra{ order:4; }
  .ag-td--note{ order:5; }
}
/* 짝수 행 배경색 */
.ag-tbody .ag-tr:nth-child(even) {
  background: #f5f5f5;
}

.consulting-note {
  padding: 16px 18px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  display: grid;
  gap: 8px;
  font-family: 'Noto Sans KR', sans-serif;
}

.consulting-note p {
  font-size: 0.95rem;
  line-height: 1.55;
  color: #333;
}

.consulting-note .contact {
  margin-top: 4px;
  font-weight: 700;
}

.bucket__group + .bucket__group {
  margin-top: 12px;
}

.bucket__group-title {
  display: block;
  margin-bottom: 4px;
  font-weight: 600;
}

.bucket__group-list .item + .item {
  margin-top: 2px;
}


/* item 기본 스타일 */
.item {
  font-size: 0.95rem;
  line-height: 1.55;
  padding: 4px 0;
}

/* 짝수 행에만 옅은 회색 배경 */
.item:nth-child(even) {
  background: #eeeeee; /* 아주 옅은 회색 */
}

/* 홀수는 기본 */
.item:nth-child(odd) {
  background: transparent;
}

/* Yes / No 칩 */
.score-yn { display:flex; justify-content:center; }

.yn-chip {   
  display: inline-flex;
  min-width: 34px;
  height: 34px;
  padding: 0 16px;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  font-size: 0.85rem;
  font-weight: 600;
  border: 1px solid #d1d5db;
  background: #f9fafb;
  color: #374151;
}

.yn-chip--yes { 
  background: #eff6ff;    /* 아주 연한 파란색 */
  border-color: #3b82f6;  /* 파란 보더 */
  color: #1e3a8a;         /* 진파랑 글씨 */
}

.yn-chip--no { 
background: #fee2e2;   /* 연한 레드 */
border-color: #ef4444; /* 메인 레드 */
color: #991b1b;        /* 딥 레드 */


}

.yn-chip--none { background:#f3f4f6; border-color:#e5e7eb; color:#6b7280; }

/* 짝수 행 배경색 (상세표) */
.ag-tbody .ag-tr:nth-child(even) { background:#f5f5f5; }

/* 반응형 */
@media (max-width:1200px){
  .fs-thead,
  .fs-tr { grid-template-columns:1fr 300px; }
  .ag-thead,
  .ag-tr { grid-template-columns:60px 1fr 240px 220px; }
}

@media (max-width:992px){
  .ov-grid { grid-template-columns:1fr; }
  .fs-thead,
  .fs-tr { grid-template-columns:1fr 260px; }
  .ag-thead,
  .ag-tr { grid-template-columns:52px 1fr 200px 1fr; }
}

@media (max-width:768px){
  .fs-thead { display:none; }
  .fs-tr { grid-template-columns:1fr; }
  .fs-th,
  .fs-td { border-top:0; padding:8px 0; }
  .ag-thead { display:none; }
  .ag-tr { grid-template-columns:1fr; gap:8px; border-top:1px solid #e5e7eb; padding:10px 12px; }
  .ag-td { padding:0; }
  .ag-td--q { order:2; }
  .td--score { order:3; }
  .ag-td--note { order:4; }
}

</style>
